import WidgetModel from '../widget-model'
import PerspectiveView from './perspective-view'

var Perspective = WidgetModel.extend({
	containerDefaults: {
		height: 160,
		width: 800
	},

	viewCls: PerspectiveView,

	isInteractive: function () {
		return false
	},

	section: function () {
		return 'scorecards'
	},

	multiSettableProps: function () {
		return [ 'background', 'fontSize', 'labelDirection' ]
	}
})

export default Perspective

Perspective.__filename__ = 'dashboards/widgets/perspective/perspective-model.js'
